import React from 'react';
import { ForgeButton, ForgeIcon } from '@tylertech/forge-react';
import { isOmni, RenderMode } from '../../types';
const buttonValues = {
    viz: 'Create visualization for my presentation ',
    query: 'Write a custom query to identify averages of ',
    findData: 'Help me find data about ',
};
const ConversationStarterButtons = ({ setChatInput, mode, renderMode, messages, chatInput }) => {
    if (!isOmni(mode) || renderMode !== RenderMode.FULL_SCREEN || messages.length > 0) {
        return null;
    }
    return (React.createElement("div", { className: "conversation-starter-button-list" }, chatInput.length === 0 ? (React.createElement(React.Fragment, null,
        React.createElement(ForgeButton, { className: "conversation-starter-button", type: "outlined", onclick: () => setChatInput(buttonValues.viz) },
            React.createElement("button", null,
                React.createElement(ForgeIcon, { name: "chart_bar" }),
                React.createElement("span", null, "Create visualization"))),
        React.createElement(ForgeButton, { className: "conversation-starter-button", type: "outlined", onclick: () => setChatInput(buttonValues.query) },
            React.createElement("button", null,
                React.createElement(ForgeIcon, { name: "code" }),
                React.createElement("span", null, "Write a custom query"))),
        React.createElement(ForgeButton, { className: "conversation-starter-button", type: "outlined", onclick: () => setChatInput(buttonValues.findData) },
            React.createElement("button", null,
                React.createElement(ForgeIcon, { name: "file_search_outline" }),
                React.createElement("span", null, "Help me find"))))) : null));
};
export default ConversationStarterButtons;
//# sourceMappingURL=ConversationStarterButtons.js.map